import Select from 'antd/lib/select'
import './index.less'

export default Select



// WEBPACK FOOTER //
// ./src/elements/select/index.js